module.exports = __webpack_public_path__ + "img/analytics.f50c9cd0.svg";